import '../scss/style.scss'
import { 
  mobileMenuToggle,
  searchCategory  
} from './components';

console.log('Hello from main.js');

mobileMenuToggle();

if (document.querySelector('#js-cat-list')){
  searchCategory(document.querySelector('#js-cat-list'))
}

